export default __webpack_public_path__ + "static/media/poorvika-Logo.9d4c3680.svg";